<template>
  <div class="app bg-dark scrollable">
    <div class="container-wide" style="padding-left:0px">
      <header class="bg-white position-relative">
        <div class="d-flex justify-content-between">
          <div class="logo align-self-center d-flex ms-3">
            <div class="d-flex ">
              <img
                src="@/assets/img/logo.png"
                height="45"
                alt="Porto Admin"
                class="system_logo"
              />
            </div>
            <div
              class="h4 font-weight-bold text-blue ms-2 mb-0 mt-0 align-self-center"
            >
              智慧景區管理平台
            </div>
          </div>
          
          <div class=" small fw-bold me-3">
            <div class="nav-item"> 
              <a class="nav-link" href="#">
                <h1 class="pb-0 mb-0" style="margin-top: 0px"> 【{{activity? activity.activityName : ''}}】</h1>
                <p  class="pb-0 mb-0" style="margin-top: 0px ;font-size:14px;">{{getTime(activity)}} </p>
                <!-- <h1 class="pb-0 mb-0" style="margin-top: 0px"> 【月光海：測試影像 】</h1>
                <p  class="pb-0 mb-0" style="margin-top: 0px ;font-size:14px;">2025/05/23 00:00 ~ 21:00 </p> -->
              </a>
            </div>
          </div>

        </div>
     
      </header>
 
      <main>
        <div class="container-fluid">
          <div class="row justify-content-center" ref="countField">
            <div class="col-md-6">
              <ul class="list-unstyled bg-black shadow-sm">
                <li> <a
                    class="d-flex flex-column flex-lg-row gap-3 align-items-start align-items-lg-center pt-3 link-body-emphasis text-decoration-none text-white"
                    href="#">
                    <div class="text-center col-12 col-lg-4">
                      <svg class="bd-placeholder-img rounded-circle border-3 border-light" width="50" height="50"
                        xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Placeholder"
                        preserveAspectRatio="xMidYMid slice" focusable="false">
                        <title>Placeholder</title>
                        <rect width="100%" height="100%" :fill="getIconColor(peopleStayCount)"></rect>
                      </svg>
                      <h5 :class="getTextCss(peopleStayCount) + ' mt-2 fw-bold'">{{getStausText(peopleStayCount)}}</h5>
                    </div>
                    <div class="col-lg-7 col-12">
                      <!-- <dl class="row">
                        <dt class="col-sm-4  fs-4">在園人數</dt>
                        <dd class="col-sm-8   fs-4 text-end event-amount">{{peopleStayCount}}<small>人</small></dd>
                        <dt class="col-sm-4  fs-4">進場人數</dt>
                        <dd class="col-sm-8   fs-4 text-end event-amount">{{peopleInCount}}<small>人</small></dd>
                      </dl> -->
                      <dl class="row">
                        <dt class="col-sm-5  col-6 fs-4">在園人數</dt>
                        <dd class="col-sm-7  col-6 fs-4 text-end event-amount">{{peopleStayCount}}<small>人</small></dd>
                        <dt class="col-sm-5  col-6 fs-4">進場人數</dt>
                        <dd class="col-sm-7  col-6 fs-4 text-end event-amount">{{peopleInCount}}<small>人</small></dd>
                      </dl>
                    </div>
                  </a> </li>
              </ul>
            </div>
            
            <!-- <div class="col-md">
              <ul class="list-unstyled bg-black shadow-sm">
                <li> <a
                    class="d-flex flex-column flex-lg-row gap-3 align-items-start align-items-lg-center pt-3 link-body-emphasis text-decoration-none text-white"
                    href="#">
                    <div class="text-center col-12 col-lg-4">
                      <svg class="bd-placeholder-img rounded-circle" width="50" height="50"
                        xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Placeholder"
                        preserveAspectRatio="xMidYMid slice" focusable="false">
                        <title>Placeholder</title>
                        <rect width="100%" height="100%" fill="var(--bs-orange)"></rect>
                      </svg>
                      <h5 class="mt-2 text-orange fw-bold">稍微擁擠</h5>
                    </div>
                    <div class="col-lg-7">
                      <dl class="row">
                        <dt class="col-sm-4 fs-4">即時車次</dt>
                        <dd class="col-sm-8 fs-4 text-end event-amount">1,510 <small>輛</small></dd>
                        <dt class="col-sm-4 fs-4">累計車次</dt>
                        <dd class="col-sm-8 fs-4 text-end event-amount">4,510 <small>輛</small></dd>
                      </dl>
                    </div>
                  </a> </li>
              </ul>
            </div> -->
            

          </div>
          <div :class="videoContentCSS">
            <div :class="videoCSS">
              <div class="card border-0" ref="panelIn">
                <div class="card-header bg-indigo text-white fw-bold"> 入口影像 </div>
                <div :style="{height: height}">
                  <video v-if="isMobileDevice" id="HlsIn" ref="HlsIn" class="w-100 h-100" style="object-fit: contain;"  autoplay playsinline muted type='video/mp4'></video>
                  <matrix v-else :groupData="cctvPeopleIn" :panelWidth='panelInWidth'></matrix> 
                </div>
              </div>
            </div>
            <div :class="videoCSS">
              <div class="card border-0" ref="panelOut">
                <div class="card-header bg-indigo text-white fw-bold"> 出口影像 </div>
                <div :style="{height: height}">
                  <video v-if="isMobileDevice" id="HlsOut" ref="HlsOut" class="w-100 h-100" style="object-fit: contain;" autoplay playsinline muted type='video/mp4'></video>
                  <matrix v-else :groupData="cctvPeopleOut" :panelWidth='panelOutWidth'></matrix>           
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>  
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import Hls from 'hls.js';
import mobileDetect from "../../utils/mobileDetect";
import Utils from "../../utils/utils";
import CONST from "../../utils/const";
import {getActivityCemeraId} from '../../utils/utils'
import Matrix from "../../components/Matrix.vue";
import { getCountPerDay } from '../../api/elasticSearch/peopleApis'
import MobileDetect from '../../utils/mobileDetect'
import { set } from 'vue';

export default {
  name: "Home",
  components: { Matrix },
  data() {
    return {
      isMobileDevice: false,
      isIOSDevice:false,
      isHlsSupport: Hls.isSupported(),
      activityIds: {},
      svgColor: {
        NORMAL: 'var(--bs-green)',
        WARN: 'var(--bs-orange)',
        DANGER: 'var(--bs-red)',
      },
      textCSS: {
        NORMAL: 'text-green',
        WARN: 'text-orange',
        DANGER: 'text-red'
      },
      height: 'calc(100vh - 250px)',
      viewPort:window.innerWidth,
      videoContentCSS: 'row justify-content-md-center',
      videoCSS: 'col-6 col-md-6',
      dataInterval: null,
      activity: null,
      startTime: '',
      endTime: '',
      peopleInCount: 0,
      peopleOutCount: 0,
      peopleStayCount: 0,
      vehicleInCount: 0,
      vehicleOutCount: 0,
      vehicleStayCount: 0,
      cctvPeopleIn: null,
      cctvPeopleOut: null,
      panelInWidth: 0,
      panelOutWidth: 0,

      reconnectAttempts: 0,  // 已重連次數
      maxReconnectAttempts: 2,  // 最大重連次數
    };
  },
  computed: {
    maxSelectTime() {
      return moment().startOf("m").toISOString();
    },
    ...mapState("scenicArea", { scenicAreaList: "allscenicArea" }),
    ...mapState("mobileDetect", { isMobileDevice: "isMobileDevice" }),

    ...mapState("activity", { activityList: "activities" }),
  },
  created() {
    this.$store.dispatch("activity/getAllActivity");
    const stopWatch = this.$watch('activityList', (newVal) => {
      console.log('activityList', newVal);
      stopWatch(); //僅監聽一次

      this.activity = this.getNowActivity(newVal);
      this.getActivityCCTV();
      // console.log('b', b);  
      })
  },
  
  watch: {
    viewPort:{
      handler(newVal){
        if(newVal < 500){
          this.videoContentCSS = 'justify-content-md-center'
          this.videoCSS = 'col-12 col-md-6'
        }else{
          this.videoContentCSS = 'row justify-content-md-center'
          this.videoCSS = 'col-6 col-md-6'
        }},
        immediate: true
    
    },
  },
  methods: {
    setVideoHeight() {
      this.isMobileDevice = MobileDetect.isMobileDevice()
      this.height = this.isMobileDevice ? "calc(50vh)" : "calc(100vh - 250px)"
    },
    async getPersonPerDay() {
      if(Utils.isEmptyObject(this.cctvPeopleIn) || Utils.isEmptyObject(this.cctvPeopleOut))
        return 

      let st = this.activity? 
        moment(this.activity.startDate).seconds(0).valueOf() : //開始查詢時間為活動開始時間 
        moment().hours(12).minute(0).second(0).valueOf() 
        if (!Utils.isEmptyObject(this.startTime)) {
        st = moment(this.startTime).valueOf()
      }

      let et = moment().valueOf()
      if (!Utils.isEmptyObject(this.endTime)) {
        et = moment(this.endTime).valueOf()
      }

      const condition1 = {
        streamingIds: [this.cctvPeopleIn[0].streamId],
        startTime: st,
        endTime: et,
        interval: '1d',
        objectTypes: [],
        dataType: ''
      }
      const condition2 = {
        streamingIds: [this.cctvPeopleOut[0].streamId],
        startTime: st,
        endTime: et,
        interval: '1d',
        objectTypes: [],
        dataType: ''
      }

      const result1In = await getCountPerDay(Object.assign({message: '(in)'}, condition1))  //入口進入
      const result1Out = await getCountPerDay(Object.assign({message: '(out)'}, condition1))  //入口出去

      const result2In = await getCountPerDay(Object.assign({message: '(in)'}, condition2))  //出口出去
      const result2Out = await getCountPerDay(Object.assign({message: '(out)'}, condition2))  //出口進入

      const entranceInCount = Utils.isEmptyObject(result1In) ? 0 : Object.values(result1In)[0]
      const entranceOutCount = Utils.isEmptyObject(result1Out) ? 0 : Object.values(result1Out)[0]
      const exitInCount = Utils.isEmptyObject(result2In) ? 0 : Object.values(result2In)[0]
      const exitOutCount = Utils.isEmptyObject(result2Out) ? 0 : Object.values(result2Out)[0]

      this.peopleInCount = entranceInCount + exitOutCount
      this.peopleOutCount = entranceOutCount + exitInCount
      this.peopleStayCount = (this.peopleInCount - this.peopleOutCount < 0) ? 0 : this.peopleInCount - this.peopleOutCount
    },

    getIconColor(value){
      const warn = this.activity? this.activity.orangeThresholdForPeople : 0
      const danger = this.activity? this.activity.redThresholdForPeople : 0

      if(value < warn) {
        return this.svgColor.NORMAL
      }
      else if(value >= warn && value < danger) {
        return this.svgColor.WARN
      } else {
        return this.svgColor.DANGER
      }
    },

    getTextCss(value){
      const warn = this.activity? this.activity.orangeThresholdForPeople : 0
      const danger = this.activity? this.activity.redThresholdForPeople : 0

      if(value < warn) {
        return this.textCSS.NORMAL
      }
      else if(value >= warn && value < danger) {
        return this.textCSS.WARN
      } else {
        return this.textCSS.DANGER
      }
    },

    getStausText(value) {
      const warn = this.activity? this.activity.orangeThresholdForPeople : 0
      const danger = this.activity? this.activity.redThresholdForPeople : 0

      if(value < warn) {
        return '正常'
      }
      else if(value >= warn && value < danger) {
        return '稍微擁擠'
      } else {
        return '擁擠'
      }
    },

    getTime: function (event) {
      var startDate = "-";
      var endDate = "-";
      if(Utils.isEmptyObject(event))
        return '-'

      if (Utils.isEmptyObject(event.startDate)) {
        startDate = "-";
      }

      if (Utils.isEmptyObject(event.endDate)) {
        endDate = "-";
      }

      startDate = moment(event.startDate).format("YYYY/MM/DD HH:mm");
      endDate = moment(event.endDate).format("YYYY/MM/DD HH:mm");

      return `${startDate} ~ ${endDate}`;
    },

    //取得活動列表中 status 為 DURING 的值
    getNowActivity(data){
      if(Utils.isEmptyObject(data)) return;
      return data.find(item => item.status === CONST.ACTIVITY_STATUS.DURING);
    },

    handleHlsError() {
      //監聽hls 串流出現錯誤
      if (this.isIOSDevice) {
            const videoIn = this.$refs.HlsIn;
            const videoOut = this.$refs.HlsOut;

            if (videoIn) {
              
                videoIn.addEventListener('error', () => {
                  if(this.reconnectAttempts < this.maxReconnectAttempts) {
                    this.reconnectAttempts++;
                    console.error(' videoIn 發生錯誤，3秒後重新連線...');
   
   
                  }else {
                    console.error('已達最大重連次數，停止嘗試重新連線。');
                  }
                });
            }
            if (videoOut) {
                videoOut.addEventListener('error', () => {
                    if(this.reconnectAttempts < this.maxReconnectAttempts) {
                      this.reconnectAttempts++;
                      console.error(' videoOut 發生錯誤，3秒後重新連線...');
                      setTimeout(() => {
                      this.getActivityCCTV();
                    }, 3000); // 延遲3秒後重新嘗試連線
                    }else {
                      console.error('已達最大重連次數，停止嘗試重新連線。');
                    }
                });
            }
        }
    },

    async getActivityCCTV(){
    console.log("this.activityIds",this.activityIds);
    this.cctvPeopleIn = this.$store.getters['videoCamera/getCCTVById'](this.activityIds.peopleIn)
    this.cctvPeopleOut = this.$store.getters['videoCamera/getCCTVById'](this.activityIds.peopleOut)

    if(Utils.isEmptyObject(this.cctvPeopleIn) || Utils.isEmptyObject(this.cctvPeopleOut)) { // 此頁重整重新呼叫api
      await this.$store.dispatch('videoCamera/getCCTV')
      this.cctvPeopleIn = this.$store.getters['videoCamera/getCCTVById'](this.activityIds.peopleIn)
      this.cctvPeopleOut = this.$store.getters['videoCamera/getCCTVById'](this.activityIds.peopleOut)
    }

    console.log('cctvPeopleIn', this.cctvPeopleIn);
    console.log('cctvPeopleOut', this.cctvPeopleOut);

    this.panelInWidth = this.$refs.panelIn.clientWidth
    this.panelOutWidth = this.$refs.panelOut.clientWidth
    
    if(this.isMobileDevice && !Utils.isEmptyObject(this.cctvPeopleIn) && !Utils.isEmptyObject(this.cctvPeopleIn[0].streamUrl) && !Utils.isEmptyObject(this.cctvPeopleOut) && !Utils.isEmptyObject(this.cctvPeopleOut[0].streamUrl)) {
      let hlsInUrl = ''
      let hlsOutUrl = ''
      // const peopleInUrlSplit = this.cctvPeopleIn[0].streamUrl.split('/') //['ws:', '', '10.179.2.35:8089', 'NVR', 'cv99001']
      // const peopleOutUrlSplit = this.cctvPeopleOut[0].streamUrl.split('/') //['ws:', '', '10.179.2.35:8089', 'NVR', 'cv99002']
      const peopleInUrlSplit = this.cctvPeopleIn[0].streamUrl.split('/') //['ws:', '', '10.179.20.35:8089', 'NVR', 'cv99001']
      const peopleOutUrlSplit = this.cctvPeopleOut[0].streamUrl.split('/') //['ws:', '', '10.179.20.35:8089', 'NVR', 'cv99002']
      if(window.location.host === "192.168.1.1") {
        
        // hlsInUrl = `https://192.168.1.1/mjpeg/StreamDecode/GetStream?rtspUrl=rtsp://${peopleInUrlSplit[2].split(':')[0]}/${peopleInUrlSplit[4]}`
        // hlsOutUrl = `https://192.168.1.1/mjpeg/StreamDecode/GetStream?rtspUrl=rtsp://${peopleOutUrlSplit[2].split(':')[0]}/${peopleOutUrlSplit[4]}`
        
        hlsInUrl = 'https://192.168.1.1/hls/cv99001/index.m3u8'
        hlsOutUrl = 'https://192.168.1.1/hls/cv99002/index.m3u8'

      } else {
         // hlsInUrl = 'https://imts.eastcoast-nsa.gov.tw/ws6/NVR/cv99001/live.m3u8'
        // hlsOutUrl = 'https://imts.eastcoast-nsa.gov.tw/ws6/NVR/cv99002/live.m3u8'

        // hlsInUrl = 'https://streamservice.wittybay-41660313.eastasia.azurecontainerapps.io/NVR/moonsea-in/live.m3u8' //測試用 HLS 影像
        // hlsOutUrl = 'https://streamservice.wittybay-41660313.eastasia.azurecontainerapps.io/NVR/moonsea-out/live.m3u8'
        
        hlsInUrl = 'https://moonsea-streamservice.redmushroom-338c70ec.eastasia.azurecontainerapps.io/NVR/AFA3A6D0-9246-4231-B4F4-1A1016F6902A/live.m3u8' //測試用 HLS 影像
        hlsOutUrl = 'https://moonsea-streamservice.redmushroom-338c70ec.eastasia.azurecontainerapps.io/NVR/94A5273A-825F-4A87-9697-0341656B5F33/live.m3u8'
        // hlsInUrl = 'http://192.168.8.143/StreamDecode/GetStream?rtspUrl=rtsp://192.168.8.53/live1.sdp' //測試機
        // hlsOutUrl = 'http://192.168.8.143/StreamDecode/GetStream?rtspUrl=rtsp://192.168.8.53/live1.sdp'
      }

      console.log('hlsInUrl  =>', hlsInUrl)
      console.log('hlsOutUrl =>', hlsOutUrl)

      const videoIn = this.$refs.HlsIn;
      videoIn.src = hlsInUrl;
      const videoOut = this.$refs.HlsOut;
      videoOut.src = hlsOutUrl;


      if (this.isIOSDevice){
          videoIn.src = hlsInUrl;
          videoOut.src = hlsOutUrl;
          //若 hls 斷線，則再次重新連接
          this.handleHlsError();
          
          
        }else if(Hls.isSupported()){
  
          var hlsIn = new Hls();
          hlsIn.loadSource(hlsInUrl);
          hlsIn.attachMedia(videoIn);
          
          var hlsOut = new Hls();
          hlsOut.loadSource(hlsOutUrl);
          hlsOut.attachMedia(videoOut);
          }else{
            console.error('HLS is not supported'); 
          }

    }
    },


  },
  async mounted() {
    this.isIOSDevice = await mobileDetect.isIosMobile();
    this.setVideoHeight()
    this.$_resizeEventHandler = () => {
      this.viewPort = window.innerWidth;
    };
    window.addEventListener('resize', this.$_resizeEventHandler);

    // this.activity = await this.$store.dispatch('activity/getActivityById', this.$route.params.id)

    this.activityIds = await getActivityCemeraId()
    console.log("this.activityIds",this.activityIds);
  
    
    this.getPersonPerDay();
    this.dataInterval = setInterval(async () => {
      this.getPersonPerDay()
    }, 1000)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.$_resizeEventHandler);
  },
  destroyed() {
    if (this.dataInterval) clearInterval(this.dataInterval)
    this.dataInterval = null
  },
};
</script>
<style scoped>
.ml-2 {
  margin-left: 0.5rem !important;
}


.scrollable {
  -webkit-overflow-scrolling:touch;
}
</style>